export default {"src":"/_next/static/media/pin-parking-color.1500ce61.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};